import { TranslationService } from '../../../services/translation.service';
import type { ITariffZoneDetails } from '../../../models/tariff-zone-details.model';
import './style.scss';

function TariffZoneSelector({
  availableTariffZones,
  selectedTariffZones,
  className = '',
  inlineControls = false,
  onChange,
}: {
  availableTariffZones: ITariffZoneDetails[];
  selectedTariffZones: ITariffZoneDetails[];
  className?: string;
  inlineControls?: boolean;
  onChange: (selectedTariffZones: ITariffZoneDetails[]) => void;
}) {
  function handleOnSelectedTariffZonesChange(tariffZone: ITariffZoneDetails) {
    onChange(selectedTariffZones.map((x) => x.number).includes(tariffZone.number) ? selectedTariffZones.filter((x) => x.number !== tariffZone.number) : [...selectedTariffZones, tariffZone]);
  }

  return (
    <div className={`tariff-zone-selector-component ${className}`}>
      <fieldset>
        <legend className="visually-hidden">
          {TranslationService.get('common.tariffzones')} {TranslationService.get('stopareasearchpage.tariffzoneexpandablebuttontext')}
        </legend>
        {availableTariffZones?.map((selectableTariffZone, index) => (
          <div key={selectableTariffZone.number} className={`form-check ${inlineControls ? 'custom-control-inline' : ''}`}>
            <input
              id={`tariffZoneSelect-${selectableTariffZone.number}`}
              type="checkbox"
              className={`form-check-input form-check-input--zone-${selectableTariffZone.shortName.toLowerCase()}`}
              name="tariffZoneSelect"
              value={selectableTariffZone.number}
              checked={selectedTariffZones.map((x) => x.number).includes(selectableTariffZone.number)}
              onChange={() => handleOnSelectedTariffZonesChange(selectableTariffZone)}
            />
            <label className={`form-check-label fw-normal d-flex align-items-center ${index > 0 ? 'mt-2' : ''}`} htmlFor={`tariffZoneSelect-${selectableTariffZone.number}`}>
              <span className="tariff-zone-translation">{TranslationService.get('common.tariffzone')}</span>
              <small className="tariff-zone-icon ms-1">{selectableTariffZone.shortName}</small>
            </label>
          </div>
        ))}
      </fieldset>
    </div>
  );
}

export default TariffZoneSelector;
